import { useState, type FormEvent } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { loginPassword, ApiError, translateError } from '../lib/api'
import { useAuth } from '../lib/store'

export default function Login() {
  const nav = useNavigate()
  const setAuth = useAuth((s) => s.setAuth)
  const [phone, setPhone] = useState('')
  const [pw, setPw] = useState('')
  const [loading, setLoading] = useState(false)
  const [err, setErr] = useState<string|null>(null)
  async function submit(e:FormEvent){e.preventDefault();setErr(null)
    if(!/^1\d{10}$/.test(phone)){setErr('手机号是 11 位数字,首位 1');return}
    if(!pw){setErr('请输入密码');return}
    setLoading(true)
    try{const r=await loginPassword(phone,pw);setAuth(r.token,r.user);nav('/')}
    catch(e){setErr(e instanceof ApiError?translateError(e.code):String((e as Error).message))}
    finally{setLoading(false)}}

  return (
    <div style={{maxWidth:380,margin:'1.5rem auto'}}>
      <h2 className="serif" style={{fontSize:'var(--fs-h2)',fontWeight:600,lineHeight:1.2,margin:0}}>手机号登录</h2>
      <p style={{marginTop:'.375rem',fontSize:'var(--fs-capt)',color:'var(--ink2)'}}>公开 · 免费 · 公益</p>
      <form onSubmit={submit} className="card" style={{marginTop:'1.25rem',padding:'1.25rem'}}>
        <div style={{marginBottom:'.75rem'}}>
          <label className="eyebrow" style={{display:'block',marginBottom:4}}>手机号</label>
          <input type="tel" inputMode="numeric" className="inp" value={phone} onChange={e=>setPhone(e.target.value.replace(/\D/g,''))} maxLength={11} autoComplete="tel" />
        </div>
        <div style={{marginBottom:'.75rem'}}>
          <label className="eyebrow" style={{display:'block',marginBottom:4}}>密码</label>
          <input type="password" className="inp" value={pw} onChange={e=>setPw(e.target.value)} autoComplete="current-password" />
        </div>
        {err && <div className="alert-err" style={{marginBottom:'.75rem'}}>{err}</div>}
        <button type="submit" disabled={loading} className="btn-ink" style={{width:'100%',justifyContent:'center'}}>{loading?'登录中…':'登录'}</button>
      </form>
    </div>
  )
}
